const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvilHalloweenHandSvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "41 104 31 104 32.79 109.41 16.59 114.65 27 121 43 121 43 104 41 104",
    style: {
      fill: "#a06b3c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111 109.89 102 105 81 105 81 119 81 121 102 121 92 113.5 111 109.89",
    style: {
      fill: "#a06b3c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.63 113 81 113 81 119 81 121 102 121 92 113.5 94.63 113",
    style: {
      fill: "#8e572e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.59 114.65 27 121 43 121 43 113 21.69 113 16.59 114.65",
    style: {
      fill: "#8e572e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,105V88h4l15.94-16,.06-9-6.79-9a4.7,4.7,0,0,0-5.6-1.5,4.86,4.86,0,0,0-.92.52l-1.31-1.42,7-17.49a4,4,0,0,0,.4-3.21l-4-15a4,4,0,1,0-7.66,2.3l3.49,13.31L75,48.42a24.94,24.94,0,0,0-3-.71,33.32,33.32,0,0,0-9.61-.21,45,45,0,0,0-4.85.82A61.52,61.52,0,0,0,47,51.77c-1.16.5-2.25,1-3.25,1.48L40,47l-7.15-9.16A4,4,0,0,0,27.72,44L33,52l2,10V78l5,10h3v33H81V105Z",
    style: {
      fill: "#60a534"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 33,
    style: {
      fill: "#b4cc7f"
    },
    width: 7,
    x: 74,
    y: 88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,121H65V101.28A11.28,11.28,0,0,0,53.72,90H43Z",
    style: {
      fill: "#55912f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,47.71l2-17.25a4,4,0,0,0-.61-2.63l-11-17a4,4,0,0,0-6.19-.66,4.06,4.06,0,0,0-.47,5.09L65.86,31,62.37,47.5A33.32,33.32,0,0,1,72,47.71Z",
    style: {
      fill: "#60a534"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,36.38a3.94,3.94,0,0,0-.94-2l-10-12a4,4,0,1,0-6,5.26L47,39V51.77a61.52,61.52,0,0,1,10.52-3.45Z",
    style: {
      fill: "#60a534"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.24,88H73V85.5A2.5,2.5,0,0,1,75.5,83H79a9.08,9.08,0,0,0,6.44-2.66l8.89-8.89a6,6,0,0,0,.56-7.76l-.62-.83A5.06,5.06,0,0,1,95,56V55l6,8.09v9.15Z",
    style: {
      fill: "#b4cc7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,88H40.15L35,77.71V60.3c10.31-5.16,29-14.53,43-8l-.07.15a7,7,0,0,1-7.37,3.91c-6.93-.93-15.5,1.34-22.14,4.13A10.53,10.53,0,0,0,42,70.21v5.94a4.85,4.85,0,0,0,.51,2.17h0A4.85,4.85,0,0,0,46.85,81h0A2.15,2.15,0,0,1,49,83.15Z",
    style: {
      fill: "#55912f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.43,107.25C102.66,101.95,103,102,102,102H90c-4,0-4,6,0,6h11.24l.94.51c-11.11,2.11-12.53,1.85-13.1,4.31s1.55,3.4,3.92,5.18H84V91c3,0,.84,1.41,19.06-16.84a3,3,0,0,0,.88-2.1c.07-9.75.27-9.79-.54-10.86l-6.79-9A7.7,7.7,0,0,0,83,58.5L84.23,64c-7.57,0-8.37-.32-9.53,1.08L67.1,74.2c-2.55,3.06,2.09,6.86,4.61,3.84l6.7-8H89a3,3,0,0,0,1.48-5.59c-1.69-7.31-2.38-8.47-.69-9.19a1.69,1.69,0,0,1,2,.54L98,64l0,6.8L83.76,85H75c-4,0-4,6,0,6h3v27H27.84l-4.11-2.51,10-3.23a3,3,0,0,0,1.93-3.79L35.15,107H40v6a3,3,0,0,0,6,0V91c4,0,4-6,0-6H41.86L38,77.29c0-.48,0-15.41-.07-15.88C35.89,51.16,36,51.12,35.5,50.34c-.39-.59-5.31-8.14-5.85-8.59A1,1,0,0,1,30.76,40c7.94,10.17,6.18,7.7,8.78,12a3,3,0,0,0,3.08,5.12c6.41-3.42,22.65-10.7,35-4.51,3.55,1.77,6.23-3.59,2.68-5.37l-.85-.4C88.86,32,89,32.4,88.56,30.7,85,17,84.31,16.46,85.72,16a1,1,0,0,1,1.22.58c4.7,17.62,4.25,15.06,3.74,16.26L86.4,43c-1.55,3.66,4,6,5.52,2.34,4.93-11.63,5.66-12.4,4.81-15.23-4.19-15.71-4-17.39-7.41-19.24a7,7,0,0,0-10,8.12l3.15,12L75.7,41.67,77,30.8a7,7,0,0,0-1.08-4.61l-11-17A7,7,0,0,0,54.08,8a7.07,7.07,0,0,0-.89,8.87l9.49,14.66L59.87,44.8h0c-2.14-10-2.05-10.69-3.51-12.36-10.5-12.6-11-14.17-14.85-14.43a6.94,6.94,0,0,0-5.07,1.72,7,7,0,0,0-.71,9.82L44,40v7.79c-.16-.26-1.46-2.46-1.64-2.68-.34-.44-7.19-9.29-7.62-9.64A7,7,0,0,0,25.43,46l4.75,7.15L32,62.3c0,16.45-.17,16,.33,17C37.56,89.82,37.61,91,40,91v10c-9.48,0-10.27-.37-11.43,1.24s-.39,2.8.42,5.24l-13.32,4.31a3,3,0,0,0-.64,5.42C26.4,124.15,25.87,124,27,124h75a3,3,0,0,0,1.8-5.4l-4.56-3.42,12.32-2.34a3,3,0,0,0,.87-5.58ZM58.22,13.63A1,1,0,0,1,59.11,12c.78.09.1-.52,11.73,17.45a1,1,0,0,1,.15.66L69.35,44.34c-1.08-.08-2.15-.12-3.23-.1L68.8,31.59C69.15,29.93,69.23,30.65,58.22,13.63ZM40.34,25.77c-1-1.27.62-2.33,1.36-1.48.49.59,10.15,12,10.31,12.72l2,9.1c-1.36.38-2.69.81-4,1.27V39C50,37.58,50.1,38.09,40.34,25.77Z",
    style: {
      fill: "#31352e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,63.9c-5.45,1.86-10.52,1-14.63.62s-4.52,5.58-.6,6c4.14.41,10.29,1.43,17.17-.92A3,3,0,0,0,66,63.9Z",
    style: {
      fill: "#31352e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvilHalloweenHandSvgrepoCom);
export default __webpack_public_path__ + "static/media/evil-halloween-hand-svgrepo-com.fe7115516a854cecb9ba26cb99c17a5c.svg";
export { ForwardRef as ReactComponent };